import store from '@/store'

let guard = (context) => new Promise((resolve, reject) => {

  if (store.getters['auth/user'] && store.getters['auth/user'].id) {
    resolve()
  } else {
    store.commit('auth/deleteToken')
    reject({
      name: 'signin',
    })
  }
})

export default {
  name: 'auth',
  run: guard
}
